<script setup>
import {onBeforeMount, reactive, ref, nextTick} from "vue";
import createTenantTherapy from "./components/createTenantTherapy/index.vue";
import router from "@/router/index.js";
import {getTherapistIgnore, updateTherapistIgnore} from "@/api/therapist/ignoreTenant.js";
import moment from "moment";
/*获取路由信息，带参则为修改*/
import {getRoute} from "@/hooks/getRoute.js";
import {ElMessage} from "element-plus";
import YTAddress from "@/components/YTAddress/index.vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {listServiceProviderIgnoreTenant} from "@/api/serviceProvider/ignoreTenant.js";
import BoxUpload from "@/components/YTBoxUpload/index.vue";
import YTCard from "@/components/YTCard/newIndex.vue";
import {getEnvironmentPhotoIgnore, updateEnvironmentPhotoIgnore} from "@/api/organize/ignoreTenant.js";
const {route} = getRoute()

// 带参则为修改
const isEdit = ref(false)
onBeforeMount(async () => {
  isEdit.value = Boolean(route.query.storeId)
  ruleForm.value.storeId = route.query.storeId
  if (isEdit.value) {
    await getDetail()
  } else {
    ElMessage.error("信息获取失败")
    loading.value = true
  }
})
// 获取商家信息
const getDetail = async () => {
  try {
    loading.value = true
    const res = await getTherapistIgnore(route.query.storeId)
    console.log("res", res)
    ruleForm.value = res
    ruleForm.value.operatingHours.map(i => {
      i.operatingTime = [moment(moment().format("YYYY-MM-DD") + " " + i.operatingStart).format("YYYY-MM-DD HH:mm:ss"), moment(moment().format("YYYY-MM-DD") + " " + i.operatingEnd).format("YYYY-MM-DD HH:mm:ss")]
    })
    let temp = [ruleForm.value.storeAddress.provinceCode, ruleForm.value.storeAddress.cityCode]
    if (ruleForm.value.storeAddress.districtCode) temp.push(ruleForm.value.storeAddress.districtCode)
    createTenantTherapyRef.value.handleReviewAddressCode(temp)
    nextTick(() => {
      createTenantTherapyRef.value.handleReviewServiceCities()
    })
    let tempRecipient = [ruleForm.value.recipientInfo.recipientAddress.provinceCode, ruleForm.value.recipientInfo.recipientAddress.cityCode]
    if (ruleForm.value.recipientInfo.recipientAddress.districtCode) tempRecipient.push(ruleForm.value.recipientInfo.recipientAddress.districtCode)
    createTenantTherapyRef.value.handleReviewRecipientAddressCode(tempRecipient)
    createTenantTherapyRef.value.handleReviewPic([ruleForm.value.storeLogo])
    console.log("ruleForm.value", ruleForm.value)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

// 加载状态
const loading = ref(false)
/*基本信息相关*/
// 基本信息表单
const ruleForm = ref({
  name: null,
  nameEn: "Coming Soon ...",
  certificationType: null,
  storeAddress: {
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    addressDetail: null,
    addressDetailEn: null
  },
  tenantId: null,
  storeId: null,
  // 营业时间
  operatingHours: [{
    operatingTime: [],
    weekdayOpen: null,
    weekdayClose: null,
    operatingStart: null,
    operatingEnd: null
  }],
  serviceCities: [],
  referralOfficer: {
    name: null,
    phone: null
  },
  nonSelfOperatedLink: null,
  serviceModeTypes: [],
  summary: null,
  summaryEn: null,
  description: null,
  descriptionEn: null,
  // 负责人信息
  contactName: null,
  phone: null,
  contactEmail: null,
  recipientInfo: {
    recipientName: null,
    recipientPhone: null,
    recipientAddress: {
      provinceCode: null,
      cityCode: null,
      districtCode: null,
      addressDetail: null
    }
  },
  assistsOperation: true
})
// 处理表单提交新建俱乐部
const handleCreateTenantTherapy = async () => {
  try {
    loading.value = true
    await updateTherapistIgnore(ruleForm.value)
    ElMessage.success("修改成功")
    router.push({ path: "/listTenantTherapy" })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 创建商家理疗服务商组件锚点
const createTenantTherapyRef = ref()

/*标签页相关*/
// 当前标签页
const currentTab = ref("1")
// 处理标签页改变
const handleTabChange = async (e) => {
  console.log("run in handleTabChange", e)
  if (currentTab.value === "2") {
    await handleSearch()
  } else if (currentTab.value === "3") {
    await handleGetEnvironmentPhotoList()
  }
}

/*理疗师信息相关*/
// 理疗师信息搜索表单
const formData = reactive({
  keyword: null
})
// 根据表单搜索信息
const handleSearch = async (mode = "init") => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    loading.value = true
    let param = {
      keyword: formData.keyword,
      providerType: "THERAPIST",
      tenantId: ruleForm.value.tenantId,
    }
    const res = await listServiceProviderIgnoreTenant(page, param);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.keyword = null
  handleSearch('btnSearch')
}
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}
// 新建理疗师
const handleAdd = () => {
  router.push({path: "/addTherapist", query: {tenantId: ruleForm.value.tenantId, storeId: ruleForm.value.storeId}})
}
// 处理查看理疗师详情
const handleGetTherapyDetail = (item) => {
  router.push({path: "/editTherapist", query: {tenantId: item.tenantId, providerId: item.providerId}})
}

/*上传图片组件相关*/
// 店铺环境上传组件锚点
const boxUploadRef = ref()
// 店铺环境图
const environmentPhotoList = ref([])
// 处理店铺环境上传成功
const handlePicSuccess = (url) => {
  environmentPhotoList.value = [];
  environmentPhotoList.value = url;
  isEnvironmentPhotoListChange.value = true
  loading.value = false;
};
// 处理店铺环境反显
const handleReviewPic = (reviewList) => {
  boxUploadRef.value.handleReview(reviewList);
};
// 处理删除店铺环境
const handlePicRemove = (url) => {
  environmentPhotoList.value = url
  isEnvironmentPhotoListChange.value = true
}

/*店铺环境相关*/
// 修改按钮展示状态
const isEnvironmentPhotoListChange = ref(false)
// 处理修改店铺环境
const handleUpdateEnvironmentPhotoList = async () => {
  try {
    loading.value = true
    await updateEnvironmentPhotoIgnore(ruleForm.value.storeId, {environmentPhotoList: environmentPhotoList.value})
    isEnvironmentPhotoListChange.value = false
    ElMessage.success("修改成功")
    handleGetEnvironmentPhotoList()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 获取店铺环境
const handleGetEnvironmentPhotoList = async () => {
  try {
    loading.value = true
    const res = await getEnvironmentPhotoIgnore(ruleForm.value.storeId)
    environmentPhotoList.value = res.environmentPhotoList
    handleReviewPic(environmentPhotoList.value)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <el-tabs
      v-model="currentTab"
      type="card"
      class="demo-tabs"
      @tab-change="handleTabChange"
  >
    <el-tab-pane label="基本信息" name="1">
    </el-tab-pane>
    <el-tab-pane label="理疗师信息" name="2">
    </el-tab-pane>
    <el-tab-pane label="机构环境" name="3" v-if="ruleForm.certificationType === 'LEGAL_PERSON'">
    </el-tab-pane>
  </el-tabs>
  <div v-loading="loading" v-show="currentTab === '1'" style="height: calc(100% - 55px)">
    <createTenantTherapy ref="createTenantTherapyRef" :is-edit="isEdit" v-model="ruleForm" @success="handleCreateTenantTherapy"></createTenantTherapy>
  </div>
  <div v-loading="loading" v-show="currentTab === '2'" style="min-height: calc(100% - 55px)">
    <div class="therapist_wrapper">
      <div class="flex_bt flex_align_t">
        <div>
          <div class="flex_left mg_b_1">
            <v-btn color="success" @click="handleAdd">
              <template v-slot:default>
                <div class="flex_bt">
                  <img
                      style="width: 14px; height: 14px; margin-right: 4px"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/plus.svg"
                  />
                  <span>理疗师</span>
                </div>
              </template>
            </v-btn>
          </div>
          <div class="tips_default">新增同时创建员工账号</div>
        </div>
        <div>
          <div class="flex_left flex_warp flex_align_t">
            <v-text-field
                v-model="formData.keyword"
                placeholder="请输入关键词搜索"
                label="关键词搜索"
                variant="outlined"
                clearable
                style="width: 250px;"

            ></v-text-field>
            <v-btn class="mg_r_1 mg_l_1" color="success" size="large" @click="handleSearch('btnSearch')">搜索</v-btn>
            <v-btn size="large" @click="handleReset">重置</v-btn>
          </div>
        </div>
      </div>
      <div style="min-height: calc(100% - 78px)">
        <div class="flex_warp" style="gap: 20px;" v-if="tableData.length > 0">
          <div class="therapist_card_box" v-for="(item, index) in tableData" :key="`tableData${index}`">
            <div class="flex mg_b_1">
              <div class="therapist_card_avatar_bg mg_r_1">
                <el-image
                    style="width: 80px; height: 80px;border-radius: 15px;"
                    :src="item.avatar"
                    :zoom-rate="1.2"
                    :max-scale="7"
                    :min-scale="0.2"
                    :preview-src-list="[item.avatar]"
                    show-progress
                    :initial-index="4"
                    fit="cover"
                />
              </div>
              <div class="therapist_card_info">
                <div class="mg_b_1">
                  <span class="therapist_card_info_label">姓名：</span>
                  <span class="therapist_card_info_content">{{item.name}}</span>
                </div>
                <div>
                  <span class="therapist_card_info_label">联系电话：</span>
                  <span class="therapist_card_info_content">{{item.phone}}</span>
                </div>
              </div>
              <div>
                <el-link v-if="ruleForm.assistsOperation" :underline="false" @click="handleGetTherapyDetail(item)">详情</el-link>
              </div>
            </div>
            <div class="flex_left flex_warp" style="gap: 10px;">
              <div class="therapist_card_tag" v-for="(sonItem, sonIndex) in item.tagList" v-show="sonIndex <= 2" :key="`tableData${index}tagList${sonIndex}`">
                {{sonItem.tagName}}
              </div>
            </div>
          </div>
        </div>
        <div style="height: 100%" class="tips_default flex_center" v-else>
          <div>
            暂无理疗师信息
          </div>
        </div>
        <YTTablePagination ref="YTTablePaginationRef" :page-size="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
      </div>
    </div>
  </div>
  <div v-loading="loading" v-show="currentTab === '3'" style="min-height: calc(100% - 55px)">
    <div class="container_box">
      <YTCard :title="`店铺环境`">
        <template #container>
          <div class="mg_b_1">
            <BoxUpload ref="boxUploadRef" :file-size="3" :ali-oss-path="'STORE_ENVIRONMENT_PHOTO_LIST'" @progress="loading = true" @success="handlePicSuccess" @remove="handlePicRemove" :limit="5"/>
          </div>
          <div>
            <v-btn color="primary" v-if="isEnvironmentPhotoListChange" @click="handleUpdateEnvironmentPhotoList">确认修改</v-btn>
          </div>
        </template>
      </YTCard>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.therapist_wrapper {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 20px;
  .therapist_card_box {
    width: 320px;
    min-height: 135px;
    background-color: #f7f7f8;
    border-radius: 15px;
    box-sizing: border-box;
    padding: 10px;
    .therapist_card_avatar_bg {
      width: 80px;
      height: 80px;
      border-radius: 15px;
      background-color: #c4c4c4;
      .therapist_card_avatar {
        width: 80px;
        height: 80px;
      }
    }
    .therapist_card_info {
      text-align: left;
      .therapist_card_info_label {
        font-weight: 500;
      }
    }
    .therapist_card_tag {
      font-size: 13px;
      background-color: #cbcbcc;
      box-sizing: border-box;
      padding: 0 6px;
      color: #fff;
      border-radius: 8px;
    }
  }
}
</style>
